import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';

export const getOrganizationSummary = () => {
  return {
    name: 'org_summary_row',
    type: WidgetType.a_stack,
    visible: true,
    relatedData: {
      direction: 'row',
      center: true,
      spacing: 6,
      className: 'flex-wrap lg:flex-nowrap items-stretch',
    },
    widgets: [
      {
        name: DefaultWidgetNames.default_stewarded_value_card,
        type: WidgetType.o_stewarded_value,
        visible: true,
      },
      {
        name: DefaultWidgetNames.default_ecological_integrity_card,
        type: WidgetType.o_ecological_integrity_index,
        visible: true,
      },
      {
        name: DefaultWidgetNames.default_total_size_card,
        type: WidgetType.o_total_size,
        visible: true,
      },
      {
        name: DefaultWidgetNames.default_total_assets_card,
        type: WidgetType.o_total_assets,
        visible: true,
      },
    ],
  };
};
